export const personalDataAgreement = {
    title: 'Согласие на обработку личных сведений',
    isBordered: true,
    blocks: [
        {
            type: 'text',
            value: 'Регистрируясь на нашем сайте, заполняя регистрационные формы, Вы как пользователь нашего сайта свободно, своей волей и в своем интересе даёте согласие на обработку ООО «4people» своих персональных данных, любыми законными способами, а именно:',
        },
        {
            type: 'text',
            value: 'сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение, с целью принятия Компанией решения о возможности взаимодействия или сотрудничества с физическим лицом, согласования с ним условий, на которых Компания может продолжить общение, сотрудничество или заключить договор, а также в целях информирования такого лица об услугах Компании путем направления соответствующей информации на его контактные данные, указанные при онлайн регистрации.',
        },
        {
            type: 'text',
            value: 'Указанное согласие дается на неограниченный срок. Это согласие может быть отозвано – для этого нужно направить в нашу Компанию заявления об отзыве согласия на обработку Ваших персональных данных, предоставленных посредством онлайн форм.',
        },
        {
            type: 'text',
            value: 'В случае достижения целей обработки, утраты необходимости для дальнейшей обработки, а также в случае отзыва согласия на обработку персональных данных, действие настоящего соглашения прекращается, и обработка Компанией Ваших персональных данных прекращается, а сами данные уничтожаются в порядке, установленном законодательством РФ.',
        },
    ],
};
